import {
  CriteriaWithPagination,
  EuiBasicTable,
  EuiBasicTableColumn,
  EuiButton,
  EuiEmptyPrompt,
  EuiImage,
  EuiLink,
  EuiSpacer,
  Pagination,
} from "@elastic/eui";
import { Anchor, Box, Button, Group, Input, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import React, { ReactNode, useEffect, useState } from "react";
import {
  isNullOrEmpty,
  isNullOrUndefined,
  isNullOrUndefinedArry,
} from "../../_base/extension/StringExtension";
import { paginationBase } from "../../_base/model/_base/BaseTable";
import { ParamSearchBase } from "../../_base/model/_base/ParamSearchBase";
import { getDataListProduct } from "../../api/ApiProduct";
import { getDataBrand } from "../../api/ApiSell";
import AppSearch from "../../common/AppSearch";
import { ComboSetProdCommand } from "../../model/Comboset";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import { _localization } from "../../config/location";
import { useForm } from "@mantine/form";
import { IconPlus, IconSearch } from "@tabler/icons-react";
import { Brand, TblItemCommand } from "../../model/ProductList";

// const noItemsFoundMsg = "Không có kết quả tìm kiếm phù hợp...";

// const visColorsBehindText = euiPaletteColorBlindBehindText();
// const optionSearch = [
//   {
//     value: true,
//     label: "Kích hoạt",
//     "data-test-subj": "titanOption",
//     color: visColorsBehindText[0],
//   },
//   {
//     value: false,
//     label: "Chưa kích hoạt",
//     color: visColorsBehindText[1],
//   },
// ];

const FormChooseItem = ({
  onChooseItem,
  indexItem,
  indexGroup,
  listItem,
}: FormChooseItemProps) => {
  const [toltal, setTotal] = useState(0);
  const [dataBrand, setDataBrand] = useState<Brand[]>();

  // const columns: Array<EuiBasicTableColumn<TblItemCommand>> = [
  //   {
  //     field: "id",
  //     name: "Id",
  //     sortable: true,
  //     truncateText: true,
  //     width: "3%",
  //   },
  //   {
  //     field: "itemName",
  //     name: "Tên sản phẩm",
  //     footer: <em>Page totals: {toltal}</em>,
  //     sortable: true,
  //     truncateText: true,
  //     width: "18%",

  //     render: (itemName: string) => (
  //       <EuiLink target="_blank">{itemName}</EuiLink>
  //     ),
  //   },
  //   {
  //     field: "primaryImage",
  //     name: "Ảnh",
  //     sortable: true,
  //     truncateText: true,
  //     width: "7%",
  //     render: (primaryImage: any) => {
  //       return (
  //         <EuiImage
  //           size=""
  //           width={60}
  //           height={80}
  //           src={primaryImage}
  //           alt="alt"
  //         />
  //       );
  //     },
  //   },
  //   {
  //     field: "brandId",
  //     name: "Thương hiệu",
  //     sortable: true,
  //     truncateText: true,
  //     width: "8%",
  //     render: (brandId: number) => {
  //       return (
  //         <EuiLink target="_blank">
  //           {dataBrand?.filter((item: any) => item?.id === brandId)[0]?.name}
  //         </EuiLink>
  //       );
  //     },
  //   },
  //   {
  //     field: "unitSellingPrice",
  //     name: "Giá bán",
  //     sortable: true,
  //     truncateText: true,
  //     render: (price: number) => {
  //       return (
  //         <>
  //           <Text fw={600} style={{ color: "red", marginRight: 4 }}>
  //             {convertToVnd(price)}
  //           </Text>
  //           <Text>vnd</Text>
  //         </>
  //       );
  //     },
  //   },
  //   {
  //     field: "discountValue",
  //     name: "Giảm giá",
  //     sortable: true,
  //     truncateText: true,
  //     render: (discountValue: number) => {
  //       return (
  //         <Box display={"flex"} style={{ flexDirection: "column" }}>
  //           <Box display={"flex"}>
  //             <Text>Giảm giá</Text>
  //             <Text fw={600} style={{ color: "red", marginLeft: 4 }}>
  //               {discountValue ? `${discountValue}%` : "0%"}
  //             </Text>
  //           </Box>
  //           <Text>so với giá gốc</Text>
  //         </Box>
  //       );
  //     },
  //   },
  //   {
  //     field: "onhandQuantyty",
  //     name: "Số lượng tồn kho",
  //     sortable: true,
  //     truncateText: true,
  //     render: (onhandQuantyty: number) => {
  //       return (
  //         <Box display={"flex"} style={{ flexDirection: "column" }}>
  //           <Box display={"flex"}>
  //             <Text>Số lượng tổng:</Text>
  //             <Text fw={600} style={{ color: "red", marginLeft: 4 }}>
  //               {onhandQuantyty}
  //             </Text>
  //           </Box>
  //           <EuiLink>
  //             {onhandQuantyty == 0 ? (
  //               <Text style={{ color: "red" }}>hết hàng</Text>
  //             ) : (
  //               <Text style={{ color: "blue" }}>còn hàng</Text>
  //             )}
  //           </EuiLink>
  //         </Box>
  //       );
  //     },
  //   },
  //   {
  //     field: "warrantyDescrition",
  //     name: "Thông tin bảo hành",
  //     sortable: true,
  //     truncateText: true,
  //     render: (warrantyDescrition: number) => {
  //       return (
  //         <Box display={"flex"} style={{ flexDirection: "column" }}>
  //           <Box display={"flex"}>
  //             <Text>Thời hạn:</Text>
  //             <EuiLink style={{ marginLeft: 4 }}>{warrantyDescrition}</EuiLink>
  //           </Box>
  //         </Box>
  //       );
  //     },
  //   },
  //   {
  //     field: "color",
  //     name: "Màu sắc",
  //     sortable: true,
  //     truncateText: true,
  //     width: "5%",
  //     render: (color: string) => (
  //       <>
  //         <div style={{ display: "flex", alignItems: "center" }}>
  //           <div
  //             style={{
  //               width: "15px",
  //               height: "15px",
  //               borderRadius: "50%",
  //               backgroundColor: color,
  //               marginRight: "8px",
  //             }}
  //           ></div>
  //           {color}
  //         </div>
  //       </>
  //     ),
  //   },
  //   {
  //     name: "Chọn",
  //     width: "8%",
  //     render: (item: TblItemCommand) => {
  //       return (
  //         <Button onClick={() => handleChooseItem(item)}>Chọn sản phẩm</Button>
  //       );
  //     },
  //   },
  // ];
  const hacomUrl = process.env.REACT_APP_BASE_WEB_HACOM_URL;
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        size: 200,
        Cell: ({ cell, row }) => (
          <Anchor
            target="_blank"
            href={`${hacomUrl}/${row.original.url}`}
            underline="always"
            onClick={(e) => e.stopPropagation()}
          >
            {cell.getValue<string>()}
          </Anchor>
        ),
      },
      {
        accessorKey: "primaryImage",
        header: "Ảnh",
        size: 120,
        Cell: ({ cell }) => (
          <img
            src={cell.getValue<string>()}
            alt="alt"
            width={100}
            height={100}
          />
        ),
      },
      {
        accessorKey: "brandId",
        header: "Thương hiệu",
        size: 100,
        Cell: ({ cell }) => {
          const brandId = cell.getValue<number>();
          const brand = dataBrand?.find((item) => item.id === brandId);
          return <Anchor target="_blank">{brand?.name || "Không rõ"}</Anchor>;
        },
      },
      {
        accessorKey: "unitSellingPrice",
        header: "Giá bán",
        size: 120,
        Cell: ({ cell }) => (
          <Box style={{ display: "flex", alignItems: "center" }}>
            <Text fw={600} c="red" mr={4}>
              {convertToVnd(cell.getValue<number>())}
            </Text>
            <Text>vnd</Text>
          </Box>
        ),
      },
      {
        accessorKey: "discountValue",
        header: "Giảm giá",
        size: 120,
        Cell: ({ cell }) => {
          const discount = cell.getValue<number>();
          return (
            <Box>
              <Box style={{ display: "flex" }}>
                <Text>Giảm giá</Text>
                <Text fw={600} ml={4} c="red">
                  {discount ? `${discount}%` : "0%"}
                </Text>
              </Box>
              <Text>so với giá gốc</Text>
            </Box>
          );
        },
      },
      {
        accessorKey: "onhandQuantyty",
        header: "Số lượng tồn kho",
        size: 120,
        Cell: ({ cell }) => {
          const qty = cell.getValue<number>();
          return (
            <Box>
              <Box style={{ display: "flex" }}>
                <Text>Số lượng tổng:</Text>
                <Text fw={600} ml={4} c="red">
                  {qty}
                </Text>
              </Box>
              <Anchor>
                {qty === 0 || qty === null ? (
                  <Text c="red">hết hàng</Text>
                ) : (
                  <Text c="blue">còn hàng</Text>
                )}
              </Anchor>
            </Box>
          );
        },
      },
      {
        accessorKey: "warrantyDescrition",
        header: "Thông tin bảo hành",
        size: 130,
        Cell: ({ cell }) => (
          <Box style={{ display: "flex" }}>
            <Text>Thời hạn:</Text>
            <Anchor ml={4}>{cell.getValue<string>()}</Anchor>
          </Box>
        ),
      },
      {
        accessorKey: "color",
        header: "Màu sắc",
        size: 120,
        Cell: ({ cell }) => {
          const color = cell.getValue<string>();
          return (
            <Box style={{ display: "flex", alignItems: "center" }}>
              <Box
                style={{
                  width: "15px",
                  height: "15px",
                  borderRadius: "50%",
                  backgroundColor: color,
                  marginRight: "8px",
                }}
              />
              <Text>{color}</Text>
            </Box>
          );
        },
      },
      // {
      //   id: "chon",
      //   header: "Chọn",
      //   size: 100,
      //   Cell: ({ row }) => (
      //     <Button onClick={() => handleChooseItem(row.original)}>
      //       Chọn sản phẩm
      //     </Button>
      //   ),
      //   enableSorting: false,
      //   enableColumnActions: false,
      // },
    ],
    []
  );
  const [loading, setLoading] = useState(false);
  const [dataItems, setDataItems] = useState<TblItemCommand[]>([]);
  const [data, setData] = useState<TblItemCommand[]>([]);
  // const [message, setMessage] = useState<ReactNode>(
  //   <EuiEmptyPrompt
  //     title={<h3>Dữ liệu rỗng !</h3>}
  //     titleSize="xs"
  //     body="Tải lại dữ liệu nếu trường hợp bạn không thấy có dữ liệu hiển thị !"
  //     actions={
  //       <EuiButton
  //         size="s"
  //         key="loadItems"
  //         onClick={async () => {
  //           await fetchDataItem();
  //         }}
  //       >
  //         Tải dữ liệu !
  //       </EuiButton>
  //     }
  //   />
  // );
  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [selectIds, setSelectIds] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [selectedOptions, setSelected] = useState();
  const [paramSearch, setParamSearch] = useState<ParamSearchBase>();
  const [rowCount, setRowCount] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  type SearchCriteria = {
    keySearch?: string;
  };
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {},
  });
  const fetchDataItem = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    // setError(undefined); //get-list?KeySearch=1&Active=true&Skip=1&Take=1
    // const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    const search = form.getValues();
    try {
      let urlSearch = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;
      if (search.keySearch) {
        urlSearch += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
      }
      // if (!isNullOrUndefined(inActive))
      //   urlSearch = urlSearch + `&Active=` + inActive;
      let callapi = await getDataListProduct(urlSearch);
      if (isNullOrUndefined(callapi) || isNullOrUndefinedArry(callapi?.data)) {
        // setMessage(noItemsFoundMsg);
        setTotal(0);
      } else {
        setDataItems(callapi?.data ?? []);
        setRowCount(callapi?.totalCount ?? 0);
        setTotal(callapi?.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      }
      return callapi?.data;
    } catch (error: any) {
      setDataItems([]);
      setIsError(true);
      return null;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  const onTableChange = async ({
    page: { index, size },
  }: CriteriaWithPagination<TblItemCommand>) => {
    setPagination({ ...pagination, pageIndex: index, pageSize: size });
  };
  const onSearch = async () => {
    await fetchDataItem();
  };
  const handleChooseItem = (item: any) => {
    // Convert single item to array of one element
    const items = [
      {
        id: item?.id,
        itemName: item?.itemName,
        unitSellingPrice: item?.unitSellingPrice,
        indexItem: indexItem,
        indexGroup: indexGroup,
      },
    ];
    onChooseItem(items);
    modals.close("item");
  };

  const onChange = (selectedOptions: any) => {
    setSelected(selectedOptions);
    if (!isNullOrUndefinedArry(selectedOptions)) {
      const value = selectedOptions[0].value;
      if (!isNullOrUndefined(value))
        setParamSearch({ ...paramSearch, inActive: value });
    } else setParamSearch({ ...paramSearch, inActive: undefined });
  };

  const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
    const key = event?.target?.value;
    if (!isNullOrUndefined(key))
      setParamSearch({ ...paramSearch, keyWord: key });
  };

  function convertToVnd(amount: number): string {
    const amountStr: string = amount?.toString();
    const chunks: string[] = [];

    for (let i = amountStr?.length - 1; i >= 0; i -= 3) {
      const chunk = amountStr?.slice(Math.max(i - 2, 0), i + 1);
      chunks.push(chunk);
    }

    const result: string = chunks.reverse().join(".");
    return result;
  }

  useEffect(() => {
    // const fetchData = async () => {
    //   await fetchDataItem();
    // };
    fetchDataItem();
  }, [pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    const fetDatabrand = async () => {
      const data = await getDataBrand();
      setDataBrand(data?.data.lists);
    };
    fetDatabrand();
  }, []);
  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);
  useEffect(() => {
    setData((prevData) => {
      const updatedData = dataItems?.filter(
        (item) =>
          !listItem?.find((itemRelation) => item.id === itemRelation.itemId)
      );
      return updatedData as TblItemCommand[];
    });
  }, [listItem, dataItems]);
  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    enableTopToolbar: false,
    enablePagination: true,
    localization: _localization,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableRowSelection: true,
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT"],
        // right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    getRowId: (row) => row.id,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      // style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (300 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);
  return (
    <>
      {/* <AppSearch
        loading={loading}
        onChange={onChange}
        onChangeText={onChangeText}
        onSearch={onSearch}
      /> */}
      <Group justify="space-between">
        <Group gap="sm">
          <Input
            placeholder="Nhập tìm kiếm"
            key={form.key("keySearch")}
            type="text"
            leftSection={<IconSearch size={20} color="#15aabf" />}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                await fetchDataItem();
              }
            }}
            mt={10}
            size="md"
            {...form.getInputProps("keySearch")}
            w={200}
            mb={10}
          />
          <Button
            mt={10}
            mb={10}
            size="md"
            color="blue"
            variant="outline"
            onClick={async () => {
              await fetchDataItem();
            }}
          >
            Tìm kiếm
          </Button>
        </Group>{" "}
        <Button
          mt={10}
          size="md"
          variant="outline"
          mb={10}
          onClick={() => {
            const selectedIds = Object.keys(rowSelection).filter(
              (key) => rowSelection[key]
            );
            const selectedItems = data.filter((item) =>
              selectedIds.includes(item.id.toString())
            );

            // Format items as an array of objects
            const formattedItems = selectedItems.map((item: any) => ({
              id: item.id,
              itemName: item.itemName,
              unitSellingPrice: item.unitSellingPrice,
              indexItem: indexItem,
              indexGroup: indexGroup,
            }));
            onChooseItem(formattedItems);
            modals.close("item");
          }}
        >
          Lưu
        </Button>
      </Group>
      {/* <EuiBasicTable
        tableCaption="Demo of EuiDataGrid with selection"
        items={data ? data : []}
        itemId="id"
        error={error}
        loading={loading}
        noItemsMessage={isNullOrUndefinedArry(data) ? message : ""}
        columns={columns}
        pagination={pagination}
        isSelectable={true}
        hasActions={true}
        responsive={true}
        onChange={onTableChange}
        compressed={true}
      /> */}
      <MantineReactTable table={table} />
    </>
  );
};

type FormChooseItemProps = {
  onChooseItem: (
    items: Array<{
      id: number;
      itemName: string;
      unitSellingPrice: number | string;
      indexItem: number;
      indexGroup: number;
    }>
  ) => void;
  indexItem: number;
  indexGroup: number;
  listItem: ComboSetProdCommand[] | null;
};

export default FormChooseItem;
